import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const containerVariants = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.6,
            delayChildren: 1.2,
        },
    },
};

const MotionLink = motion(Link)

const itemVariants = {
    hidden: {
        x: 40,
        opacity: 0,
    },
    show: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 1.2,
            ease: [0.22, 1, 0.36, 1],
        },
    },
};

export function BannerContent({
    isActive,
    titleSmall,
    titleBig,
    cta,
    ctaLink,
    accentColor = 'red',
}) {
    const accentClasses = {
        red: 'text-green-600 border-green-600 hover:bg-green-600',
        blue: 'text-green-600 border-green-600 hover:bg-green-600',
        green: 'text-green-600 border-green-600 hover:bg-green-600',
    };
    console.log({ cta, ctaLink })

    return (
        <motion.div
            key={isActive ? 'show' : 'hide'}
            variants={containerVariants}
            initial="hidden"
            animate={isActive ? 'show' : 'hidden'}
            className="relative z-10 max-w-xl text-left"
        >
            {/* Linha pequena */}
            <motion.p
                variants={itemVariants}
                className="text-white text-mega mb-2"
            >
                {titleSmall}
            </motion.p>

            {/* Linha grande + botão */}
            <motion.div
                variants={itemVariants}
                className="flex items-end gap-6"
            >
                <h2
                    className={`
            text-mega md:text-7xl
            font-extrabold
            leading-none
            ${accentClasses[accentColor]?.split(' ')[0]}
          `}
                >
                    {titleBig}
                </h2>

                {cta && ctaLink && (
                    <MotionLink
                        to={ctaLink}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className={`
      inline-flex items-center justify-center
      px-12 py-2
      border-2
      font-semibold
      rounded-full
      transition-colors
      text-black
      hover:text-white
      ${accentClasses[accentColor]}
    `}
                    >
                        {cta}
                    </MotionLink>
                )}

            </motion.div>
        </motion.div>
    );
}


